<script lang="ts" setup>
    import '../../../css/choice.css';   
    import {onMounted,watch,computed,reactive} from 'vue';  
    import ActionButtonV2 from '../../components/ActionButtonV2.vue'; 
    import {ButtonDisplaySize,ButtonDisplayStyle,ModalSize} from '../../Enums/UiEnums'; 
    import {ClaimSimpleLists} from '../../lib/Models/ClaimModel';  
    import SimpleList from '../../components/SimpleList.vue';
    import ModalDialog from "../../components/ModalDialog.vue";
    import {initPinia} from '../../lib/PiniaMgr';
    import {useSimpleListStore} from '../../lib/Stores/SimpleListStore'; 
    import {ActionButtonStyle} from '../../lib/Types/Types';  
    
    const emit = defineEmits<{
        (e: "onDisplay", updateCreditCard: boolean, paymentMethodId: number, cardInformation: string) : void
    }>();

    const simpleListStore = useSimpleListStore(initPinia());
    const formData = reactive <
    {      
        patient_id: number,
        paymentMethodId?: number,
        cardInformation?: string,
        modalDisplayAddCard: boolean,
    }>({      
        patient_id: 0,
        modalDisplayAddCard: false
    });
    const props = withDefaults(defineProps<{ 
        show: boolean,
        patientId: number,
        patientName?: string,
        paymentMethodId?: number,
        refreshCards: number 
    }>(),
    {
        show: false,
        patientId: 0,
        patientName: "Unknown",
        refreshCards: 0
    }); 
    onMounted(async () => {  
        formData.modalDisplayAddCard = props.show;
        formData.patient_id = props.patientId;
        formData.paymentMethodId = props.paymentMethodId;
    });
    watch(() => props.refreshCards, (newID, oldID) => {
        if ((newID !== oldID) && (newID > 0))  {
            refreshCreditCardList();
        }
    });
    const creditCardListLoaded = computed<boolean>(()=> {
        if (!simpleListStore) {
            return false;
        }
        if (!simpleListStore.listResult[ClaimSimpleLists.CreditCard]) {
            return false;
        }
        if (simpleListStore.listResult[ClaimSimpleLists.CreditCard].length === 0) {
            return false;
        }
        return true;
    });
    const disableConnects = computed<boolean>(()=> {
        if ((formData.paymentMethodId ?? 0) > 0) {
            return false;
        }
        return true;
    });
    function onChangeCreditCard(selectedItem : any) : void {
        formData.paymentMethodId = selectedItem.value;
        formData.cardInformation = selectedItem.description;
    }
    async function refreshCreditCardList() : Promise<void> {
        const where_clause = "patient_id^" + props.patientId.toString(); 
        await simpleListStore.getSimpleWhereList(ClaimSimpleLists.CreditCard,where_clause); 
    }
    async function modalHiddenResponse() : Promise<void> {
        formData.modalDisplayAddCard = false;
        emit("onDisplay",false,0,"");
    }
    async function connectCreditCard() : Promise<void> {
        formData.modalDisplayAddCard = false;
        emit("onDisplay",true,formData.paymentMethodId ?? 0,formData.cardInformation ?? "");
    }
    async function disconnectCreditCard() : Promise<void> {
        formData.modalDisplayAddCard = false;
        emit("onDisplay",true,0,"");
    }
    async function getNewCreditCard() : Promise<void> {
        const window_features = "popup=yes,resizable=yes,width=940,height=500,top=10,left=10";
        const window_url = `/officemd/App/billing/PaySimpleCreditCard?CCOnly=1&PID=${props.patientId}&Name=${props.patientName}`
        window.open(window_url,"credit_popup",window_features); 
    }
</script> 
 
<template>
    <ModalDialog 
        :show="formData.modalDisplayAddCard"
        @hidden="modalHiddenResponse"  
        :size="ModalSize.Medium"
        :closeOnClickOutside=false>
        <template #title>
            <span >Add Credit Card</span> 
        </template>
        <div>
            <SimpleList v-show="creditCardListLoaded"
                :listName="ClaimSimpleLists.CreditCard"
                :includeHeader="true"
                :includeBlank="false" 
                v-model:selected="formData.paymentMethodId"
                @onChange="onChangeCreditCard" 
            />
        </div>
        <template #footer> 
            <ActionButtonV2 
                :action="ActionButtonStyle.New"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'New'"
                :performAction="getNewCreditCard"
                :endingPadding="1"
            />
            <ActionButtonV2 
                :action="ActionButtonStyle.Refresh"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'Refresh'"
                :performAction="refreshCreditCardList"
                :endingPadding="1"
            />
            <ActionButtonV2 
                :action="ActionButtonStyle.Add"
                :disabled="disableConnects"
                :text="'Connect'"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'Connect'"
                :performAction="connectCreditCard"
                :endingPadding="1"
            />
            <ActionButtonV2 
                :action="ActionButtonStyle.Trash"
                :disabled="disableConnects"
                :text="'Disconnect'"
                :size="ButtonDisplaySize.Small" 
                :displayStyle="ButtonDisplayStyle.OutlinePrimary" 
                :spinText="'Disconnect'"
                :performAction="disconnectCreditCard"
            />
        </template>
    </ModalDialog>
</template>
